export default () => ({
    box: {
        margin: '20px 0',
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
    },
});
